<template>
    <div class="ui-modal">
        <div class="ui-modal--close-wrap">
            <div class="ui-modal--close">
                <button class="ui-modal--close-button" @click.prevent="onCloseRequested">
                    <!-- TODO: handle icons -->
                </button>
            </div>
        </div>

        <header class="ui-modal--header" v-if="!!$slots.header">
            <slot name="header"/>
        </header>
        <main class="ui-modal--body" v-if="!!$slots.default">
            <slot/>
        </main>
        <footer class="ui-modal--footer" v-if="!!$slots.footer">
            <slot name="footer"/>
        </footer>
    </div>
</template>

<script>
    export default {
        mixins: [
        ],
        methods: {
            onCloseRequested() {
                this.$emit('close');
            },
        },
    };
</script>
